// src/pages/Impressum.js

import React from 'react';
import { Container, Typography, Box, Paper, AppBar, Toolbar, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { AccountBalance as AccountBalanceIcon } from '@mui/icons-material';

const Impressum = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ bgcolor: '#f8fafc', minHeight: '100vh' }}>
      {/* Navigation */}
      <AppBar position="sticky" elevation={0} sx={{ bgcolor: '#1a365d' }}>
        <Toolbar>
          <Typography 
            variant="h6" 
            sx={{ 
              flexGrow: 1, 
              fontWeight: 700,
              color: 'white',
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              cursor: 'pointer'
            }}
            onClick={() => navigate('/')}
          >
            <AccountBalanceIcon sx={{ color: '#00bcd4' }} /> immo-automation
          </Typography>
          <Button 
            onClick={() => navigate('/')}
            sx={{ color: 'white' }}
          >
            Zurück zur Startseite
          </Button>
        </Toolbar>
      </AppBar>

      <Container maxWidth="md" sx={{ py: 8 }}>
        <Paper elevation={0} sx={{ p: 6, borderRadius: 3, border: '2px solid #e2e8f0' }}>
          <Typography variant="h3" sx={{ fontWeight: 700, mb: 4, color: '#1a365d' }}>
            Impressum
          </Typography>

          <Box sx={{ mb: 4 }}>
            <Typography variant="h6" sx={{ fontWeight: 700, mb: 2, color: '#1a365d' }}>
              Angaben gemäß § 5 TMG
            </Typography>
            <Typography variant="body1" sx={{ mb: 1 }}>
              immo-automation GmbH<br />
              Brechtestraße 64<br />
              48431 Rheine
            </Typography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Typography variant="h6" sx={{ fontWeight: 700, mb: 2, color: '#1a365d' }}>
              Kontakt
            </Typography>
            <Typography variant="body1" sx={{ mb: 1 }}>
              Telefon: +49 152 22096381<br />
              E-Mail: info@immo-automation.de<br />
              Website: www.immo-automation.de
            </Typography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Typography variant="h6" sx={{ fontWeight: 700, mb: 2, color: '#1a365d' }}>
              Vertreten durch
            </Typography>
            <Typography variant="body1" sx={{ mb: 1 }}>
              Geschäftsführer: Steffen Göcking
            </Typography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Typography variant="h6" sx={{ fontWeight: 700, mb: 2, color: '#1a365d' }}>
              Registereintrag
            </Typography>
            <Typography variant="body1" sx={{ mb: 1 }}>
              Eintragung im Handelsregister<br />
              Registergericht: Amtsgericht Steinfurt<br />
              Registernummer: HRB 14814
            </Typography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Typography variant="h6" sx={{ fontWeight: 700, mb: 2, color: '#1a365d' }}>
              Umsatzsteuer-ID
            </Typography>
            <Typography variant="body1" sx={{ mb: 1 }}>
              Umsatzsteuer-Identifikationsnummer gemäß §27 a Umsatzsteuergesetz:<br />
              DE369007103
            </Typography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Typography variant="h6" sx={{ fontWeight: 700, mb: 2, color: '#1a365d' }}>
              Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV
            </Typography>
            <Typography variant="body1" sx={{ mb: 1 }}>
              Steffen Göcking<br />
              Brechtestraße 64<br />
              48431 Rheine
            </Typography>
          </Box>

          <Box>
            <Typography variant="h6" sx={{ fontWeight: 700, mb: 2, color: '#1a365d' }}>
              Haftungsausschluss
            </Typography>
            <Typography variant="body2" sx={{ color: '#64748b', lineHeight: 1.8 }}>
              Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, 
              Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. 
              Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten 
              nach den allgemeinen Gesetzen verantwortlich.
            </Typography>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default Impressum;
